import { subscribe } from '../../../common/errors/sagas';
import { notificationError } from '../../../common/errors/notificationTypes';

const pre = 'WEBJOBS/DETAILS/';

export const WEB_JOBS_DETAILED_LOADED = `${pre}WEB_JOBS_DETAILED_LOADED`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_ROWS = `${pre}SET_ROWS`;
export const RETURN_TO_DATA_LOAD = `${pre}RETURN_TO_DATA_LOAD`;
export const FETCH_DATA_LOADS_FAILED = `${pre}FETCH_DATA_LOADS_FAILED`;

subscribe(FETCH_DATA_LOADS_FAILED, 'Error loading new data for the page', notificationError);

export const fetchDataLoadsFailed = error => ({
    type: FETCH_DATA_LOADS_FAILED,
    error
});

export const returnToDataLoad = () => ({
    type: RETURN_TO_DATA_LOAD
});

export const webJobsDetailedLoaded = search => ({
    type: WEB_JOBS_DETAILED_LOADED,
    search
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const setRows = rows => ({
    type: SET_ROWS,
    rows
});
